import { Feature } from "./config";

// Define the alternate favicon for India warehouse domain
export const GREEN_BADGE_FAVICON =
  "https://m.media-amazon.com/images/G/31/HVH-CareerSite/IN_CS/VendorImages/hbaGBFavicon.svg";

// Check if we're on the India warehouse domain
export const isIndiaWarehouseDomain = () =>
  window.location.hostname.includes("warehousejobs.in");

// Set the alternate favicon for India warehouse domain
export const overwriteFaviconForGB = () => {
  if (isIndiaWarehouseDomain()) {
    const setFavicon = () => {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = GREEN_BADGE_FAVICON;
        favicon.type = "image/svg+xml"; // Ensure proper SVG handling
      } else {
        const newFavicon = document.createElement("link");
        newFavicon.rel = "icon";
        newFavicon.type = "image/svg+xml";
        newFavicon.href = GREEN_BADGE_FAVICON;
        document.head.appendChild(newFavicon);
      }
    };

    // Set favicon when DOM is ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setFavicon);
    } else {
      setFavicon();
    }
  }
};

// Check if the current configuration is valid based on domain and country settings
export const isValidFeatureForIAHDomain = (country, configuration) => {
  if (process.env.NODE_ENV === "development") return true;

  // For India warehouse domain, check if country is India and feature is GRIEVANCE_REPORTING_PHONE
  if (isIndiaWarehouseDomain()) {
    return (
      country === "India" &&
      configuration?.feature === Feature.GRIEVANCE_REPORTING_PHONE
    );
  }

  // For non-India warehouse domains, check if not trying to use India grievance feature
  return !(
    country === "India" &&
    configuration?.feature === Feature.GRIEVANCE_REPORTING_PHONE
  );
};
